export enum ConsentChoice {
  ACCEPTED = "accepted",
  REFUSED = "refused",
}
